import { render, staticRenderFns } from "./PlayListItem.vue?vue&type=template&id=fa353456&scoped=true"
import script from "./PlayListItem.vue?vue&type=script&lang=js"
export * from "./PlayListItem.vue?vue&type=script&lang=js"
import style0 from "./PlayListItem.vue?vue&type=style&index=0&id=fa353456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa353456",
  null
  
)

export default component.exports